import { Component, onCleanup, onMount } from "solid-js";

const px = (value: number | undefined) =>
  typeof value === "number" ? `${value}px` : value;

export const Blob: Component = () => {
  let blob: HTMLDivElement | undefined;

  const onPointerMove = (e: MouseEvent) => {
    blob?.animate(
      {
        left: px(e.clientX),
        top: px(e.clientY),
      },
      { duration: 5000, fill: "forwards" }
    );
  };

  onMount(() => {
    document.body.addEventListener("pointermove", onPointerMove);
  });

  onCleanup(() => {
    document.body.removeEventListener("pointermove", onPointerMove);
    blob = undefined;
  });

  return (
    <div
      class="bg-blob rounded-1/2 animate-spin-blob absolute top-[50vh] left-[50vh] h-[30vh] w-[30vw]"
      // NOTE: Tailwind supports `transform: translate(x, y);` but we need `translate: x y;`
      style={{ translate: "-50% -50%" }}
      ref={blob}
    />
  );
};
